import React from 'react'
import style from '../card.module.css'
function Nda() {
  return (
    <div className={style.syllabus_card}>
    <div>    
        <h3>UPSC NDA</h3>  
        <p>2 upcoming . 346 courses</p>      
    </div>   
    
        <p>UPSC NDA</p>      
    
    </div>
  )
}
export default Nda